(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/analytics/assets/javascripts/trackanalytics.js') >= 0) return;  svs.modules.push('/components/core/analytics/assets/javascripts/trackanalytics.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.core = svs.core || {};
  svs.core.analytics = svs.core.analytics || {};
  var metric = new svs.core.log.Message(svs.core.log.MessageType.pageview);
  window.dataLayerPush(svs.core.analytics.data.svsanalytics.user);
  window.dataLayerPush({
    event: 'pageview',
    page: {
      pageInfo: {
        pageID: document.location.pathname,
        pageName: document.title,
        destinationURL: document.location.pathname + document.location.search,
        sysEnv: svs.core.analytics.data.svsanalytics.formFactor
      },
      webPropertyId: svs.core.analytics.data.svsanalytics.config.account
    }
  });
  window.eddl.eddlPush('siteProperties', {
    AASuite: svs.core.analytics.data.svsanalytics.adobeLaunch.suite,
    formFactor: svs.core.analytics.data.svsanalytics.formFactor,
    site: svs.core.analytics.data.svsanalytics.adobeLaunch.site
  });
  window.eddl.eddlPush('user', svs.core.analytics.data.svsanalytics.adobeUser);
  window.eddl.eddlPush('pageView', {
    pageName: document.location.pathname.substring(1).replace(/\//g, ':'),
    url: location.pathname + location.search,
    formFactor: svs.core.analytics.data.svsanalytics.formFactor
  });
  svs.core.log.track('svs.core.analytics', metric);

  svs.core.analytics.timingTest = pageTimingsTest;

  $(document).ready(function() {
    pageTimingsTest();
  });

  function testPerformance(measurements) {
    var perf = window.performance || window.webkitPerformance;
    perf = perf && perf.timing;
    if (perf && perf.navigationStart !== 0) {
      var navstart = perf.navigationStart;
      measurements.totalPageLoadTime = perf.loadEventStart - navstart;
      measurements.serverResponseTime = perf.responseStart - perf.requestStart;
      measurements.pageDownloadTime = perf.responseEnd - perf.responseStart;
      measurements.pageInteractive = perf.domInteractive - navstart;
    }
  }
  function pageTimingsTest() {
    var sendLog = true;
    var perf = window.performance || window.webkitPerformance;
    perf = perf && perf.timing;
    if (perf) {
      if (perf.loadEventEnd < 1) {
        setTimeout(function() {
          pageTimingsTest();
        }, 200);
      } else {
        var sampleRate = parseInt(svs.core.analytics.data.svsanalytics.config.siteSpeedSampleRate, 10);
        var sampleNumber = Math.floor(Math.random() * (100 + 1));
        if (sampleNumber <= sampleRate) {
          var logdata = {};
          testPerformance(logdata);
          if (!$.isEmptyObject(logdata)) {
            $.each(logdata, function(key, value) {
              if (!parseInt(value, 10)) {
                sendLog = false;
              }
            });
            if (sendLog) {
              var timings = new svs.core.log.Message(
                svs.core.log.MessageType.timing
              );
              timings.totalPageLoadTime = logdata.totalPageLoadTime;
              timings.serverResponseTime = logdata.serverResponseTime;
              timings.pageDownloadTime = logdata.pageDownloadTime;
              timings.interactivePage = logdata.pageInteractive;
              svs.core.log.track('svs.core.analytics', timings);
            }
          }
        }
      }
    }
  }
})(svs);

 })(window);